import { colors, fonts } from '@grupoboticario/flora-tokens/dist/casaMagalhaesOceano/web/ds'

export const casaMagalhaesOceano = {
  colors,
  fonts,
}
